const urls = JSON.parse(process.env.REACT_APP_SHOP_URL ?? '');

export default function getShopUrl(locale: string): string | undefined {
    return urls[locale];
}